module.exports = __webpack_public_path__ + "0e01ef036039d180850353a60ab57124.mp3";